<template>
  <div id="app">
    <router-view v-slot="{ Component, route }">
      <keep-alive :include="['Main', 'Receiving', 'ReceivingRegister', 'Shipping', 'ShippingRegister', 'Inventory']">
        <component :is="Component" :key="route.name" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script>
import { onMounted } from 'vue'
import { useAuthStore } from './stores/auth'

export default {
  name: 'App',
  setup() {
    const authStore = useAuthStore()

    onMounted(() => {
      authStore.initializeAuth()
    })

    return {}
  }
}
</script>

<style>
#app {
  height: 100vh;
  overflow: hidden;
}
</style>
